import { GenericFields } from "./GenericFields";

export class Correspondance extends GenericFields{
  codeDivalto: string = '';
  libelleDivalto: string = '';
  libelleRg: string = '';
  libelleBit: string = '';
}
